import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailSupportFehler extends GuiDetailGeneric {
    constructor() {
        super("Fehler");
    }
}
